import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';
import { createApp }  from "vue";
import router from "./router";
import themes from "devextreme/ui/themes";

import App from "./App";
import appInfo from "./app-info";
import developLang from "./utils/develop-lang";

import Form from "devextreme/ui/form";
import Config from "devextreme/core/config";

import { licenseKey } from './devextreme-license';

Config({
    licenseKey,
    forceIsoDateParsing: true,
    editorStylingMode: 'filled',
});

Form.defaultOptions({
    device: [
        { deviceType: 'desktop' },
        { deviceType: 'tablet' },
        { deviceType: 'phone' },
    ],
    options: {
        labelMode: 'static',
        // labelAlign: 'left'
    }
});

themes.initialized(() => {
    const app = createApp(App);
    app.use(router);
    app.use(developLang);
    app.config.globalProperties.$appInfo = appInfo;
    app.mount('#app');
});
